// THIS TYPE WAS AUTOGENERATED
/// <reference path="PageViewData.ts" />
module AI
{
"use strict";
    export class PageViewPerfData extends AI.PageViewData
    {
        public ver: number;
        public url: string;
        public perfTotal: string;
        public name: string;
        public duration: string;
        public networkConnect: string;
        public referrer: string;
        public sentRequest: string;
        public referrerData: string;
        public receivedResponse: string;
        public domProcessing: string;
        public properties: any;
        public measurements: any;
        
        constructor()
        {
            super();

            this.ver = 2;
            this.properties = {};
            this.measurements = {};
            
            super();
        }
    }
}
